import angular from "angular";
import CKEditorInline from "../../RichTextEditor/Editors/CKEditor/CKEditorInline";
import "./editor-inline.scss";

/**
 * Inline editor component
 */
let editorInline = {
    bindings: {
        model: '=',
        options: '<'
    },
    template: require('./editor-inline.html')
};

export default angular.module('cms.editor.inline', [CKEditorInline]).component('editorInline', editorInline).name;



// WEBPACK FOOTER //
// ./src/cmsCore/RichTextEditor/EditorInline/EditorInline.js